import { Button } from "@components";
import classnames from "classnames/bind";
import React from "react";
import { Handle } from "reactflow";

import { If } from "@components/control-statements";
import style from "@styles/pages/cdp/cdp-base-node.module.scss";
import classNames from "classnames/bind";
import { VariableSchema } from "../../VariableSchema";
import { TreeClauses } from "./nodes/TreeClauses";

const css = classNames.bind(style);

const DEFAULT_HANDLE_STYLE = {
  width: 10,
  height: 10,
  top: 60,
};

export default function CdpBaseNode({
  title,
  type,
  selected,
  isConnectable,
  data,
  valueType,
  valid = true,
}) {
  const cx = classnames.bind(style);

  const orderType =
    type.startsWith("o.") || type.startsWith("k.") || type.startsWith("w.");
  const customerType = type.startsWith("c.");
  const couponType = type.startsWith("cc.");
  const productType = type.startsWith("p.") || type.startsWith("op.");

  const valid_clauses =
    data.items?.reduce((t, c) => t + VariableSchema.countValidClauses(c), 0) ||
    0;

  const getIcon = () => {
    if (orderType) return "receipt";
    if (customerType) return "users";
    if (couponType) return "ticket-simple";
    if (productType) return "pot-food";
  };

  const handleClickFlow = (e, detail) => {
    e.stopPropagation();
    e.preventDefault();
    e.target.parentNode.dispatchEvent(
      new CustomEvent("click", {
        bubbles: true,
        detail: { ...detail },
      })
    );
  };

  return (
    <div className={cx({ selected: selected })}>
      <div
        className={cx({
          inner: true,
          needsSetup: !valid,
          hasData: valid_clauses,
        })}
      >
        <div className={style.header}>
          <div className="d-flex align-center">
            <div
              className={css({
                icon: true,
                pedidos: orderType,
                clientes: customerType,
                cupons: couponType,
                produtos: productType,
              })}
            >
              <i className={`fal fa-${getIcon()}`} />
            </div>
            <div className={style.title}>{title}</div>
          </div>
        </div>
        <If cond={valid_clauses}>
          <TreeClauses
            data={data}
            valueType={valueType}
            onClick={(e, data) => handleClickFlow(e, data)}
          />
        </If>
      </div>
      <Handle
        type="source"
        className={style.handleSource}
        isConnectable={isConnectable}
        style={{ ...DEFAULT_HANDLE_STYLE }}
      />
      <Handle
        type="target"
        className={style.handleTarget}
        isConnectable={isConnectable}
        style={{ ...DEFAULT_HANDLE_STYLE }}
      />
    </div>
  );
}
